import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const IDLE_LIMIT = 6 * 60 * 60 * 1000; // 6 hours in ms
const CHECK_INTERVAL = 60 * 1000;       // check every 60 seconds
const STORAGE_KEY = 'tt_last_active';

export function useIdleLogout() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!currentUser) return;

    const stamp = () => localStorage.setItem(STORAGE_KEY, Date.now().toString());

    const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];
    let throttleId = null;
    const throttledStamp = () => {
      if (throttleId) return;
      throttleId = setTimeout(() => { stamp(); throttleId = null; }, 5000);
    };

    stamp(); // record now as active
    EVENTS.forEach(ev => window.addEventListener(ev, throttledStamp, { passive: true }));

    timerRef.current = setInterval(() => {
      const last = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
      if (last && Date.now() - last > IDLE_LIMIT) {
        logout();
        navigate('/', { replace: true });
      }
    }, CHECK_INTERVAL);

    return () => {
      EVENTS.forEach(ev => window.removeEventListener(ev, throttledStamp));
      clearInterval(timerRef.current);
      if (throttleId) clearTimeout(throttleId);
    };
  }, [currentUser, logout, navigate]);
}
